// Utilitários compartilhados pelos services da Clínica (filtro/paginação +
// derivação de campos de apresentação a partir dos dados canônicos da API).

// Paleta de avatar do DS (mesma usada nas telas). Determinística por índice.
const AVATARS = ["av-rose", "av-blue", "av-green", "av-amber", "av-slate"];

/** Iniciais (até 2) a partir de um nome. */
export function initialsOf(name) {
  return String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(w => w[0])
    .join("")
    .toUpperCase();
}

/** Classe de avatar determinística por índice (rotaciona a paleta do DS). */
export function avatarClassFor(index) {
  return AVATARS[
    (((Number(index) || 0) % AVATARS.length) + AVATARS.length) % AVATARS.length
  ];
}

/** scheduled_at ISO → rótulo 'DD/MM/AAAA · HH:MM' lendo os componentes literais
 *  (sem Date, para não sofrer deslocamento de fuso). */
export function slotLabel(iso) {
  if (!iso) return "";
  const [date, rest] = String(iso).split("T");
  if (!rest) return date;
  const [y, m, d] = date.split("-");
  return `${d}/${m}/${y} · ${rest.slice(0, 5)}`;
}

/** Normaliza texto para busca case/acento-insensível. */
export function norm(s) {
  return (s || "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");
}

/** Aplica busca textual sobre uma lista de campos. */
export function search(list, term, fields) {
  const t = norm(term);
  if (!t) return list;
  return list.filter(item => fields.some(f => norm(item[f]).includes(t)));
}

/**
 * Pagina uma lista. Devolve { items, total, page, per, pages }.
 * @param {Array} list
 * @param {{ page?: number, per?: number }} [opts]
 */
export function paginate(list, { page = 1, per = 10 } = {}) {
  const total = list.length;
  const pages = Math.max(1, Math.ceil(total / per));
  const p = Math.min(Math.max(1, Number(page) || 1), pages);
  const start = (p - 1) * per;
  return {
    items: list.slice(start, start + per),
    total,
    page: p,
    per,
    pages
  };
}
